"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            flex: '0 0 auto',
        },
        hoverDefault: {
            '.hoverable:hover &, .hoverable:focus-within &': {
                fill: "".concat(theme_1.default.textColors.highlight, " !important"),
            },
        },
        hoverError: {
            '.hoverable:hover &, .hoverable:focus-within &': {
                fill: "".concat(theme_1.default.textColors.error, " !important"),
            },
        },
        hoverPrimaryDark: {
            '.hoverable:hover &, .hoverable:focus-within &': {
                fill: "".concat(theme_1.default.colors.primaryDark, " !important"),
            },
        },
        hoverErrorDark: {
            '.hoverable:hover &, .hoverable:focus-within &': {
                fill: "".concat(theme_1.default.colors.errorDark, " !important"),
            },
        },
        hoverOpacity: {
            '.hoverable:hover &, .hoverable:focus-within &': {
                opacity: '0.5',
            },
        },
    });
});
